/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { FC } from "react";

import { ChevronRight } from "@mui/icons-material";

import { RequestDocument } from "@/shared/domain";

import { StyledRequestDocumentsListMobile } from "./styled";

type RequestDocumentListProps = {
    documents: RequestDocument[];
    onOpen: (document: RequestDocument) => void;
};
const RequestDocumentList: FC<RequestDocumentListProps> = ({ documents, onOpen }) => {
    return (
        <StyledRequestDocumentsListMobile>
            <ul>
                {documents.map((document) => {
                    return (
                        <li
                            className="requestDocumentsItem"
                            onClick={() => onOpen(document)}
                            key={`document-${document.id}`}
                        >
                            <span className="requestDocumentsTitle"> {document.title} </span>
                            <span className="iconArrow">
                                <ChevronRight />
                            </span>
                        </li>
                    );
                })}
            </ul>
        </StyledRequestDocumentsListMobile>
    );
};
export default RequestDocumentList;
